/* Qimati audit fixes 2026-10-07 — keyboard and screen-reader support layered on the Ella theme.
   Adds roles, names, states and Enter/Space handlers only. Never touches the cart drawer, checkout or Shiprocket code.
   Undo: remove the <script src="qm-a11y.js"> line from layout/theme.liquid. */
(function () {
  'use strict';
  var d = document;
  function each(sel, fn, root) { try { Array.prototype.forEach.call((root || d).querySelectorAll(sel), function (el) { try { fn(el); } catch (e) {} }); } catch (e) {} }
  function visible(el) { if (!el) return false; var r = el.getBoundingClientRect(); var cs = getComputedStyle(el); return r.width > 0 && r.height > 0 && cs.visibility !== 'hidden' && cs.display !== 'none'; }
  function keyButton(el, label) {
    if (el.dataset.qmKb) return; el.dataset.qmKb = '1';
    var tag = el.tagName;
    if (tag !== 'BUTTON' && tag !== 'INPUT' && !(tag === 'A' && el.hasAttribute('href'))) { if (el.tabIndex < 0 || !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0'); }
    if (!el.getAttribute('role') && tag !== 'BUTTON') el.setAttribute('role', 'button');
    if (label && !el.getAttribute('aria-label') && !el.textContent.trim()) el.setAttribute('aria-label', label);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { if (tag === 'BUTTON' || (tag === 'A' && e.key === 'Enter')) return; e.preventDefault(); el.click(); }
    });
  }
  var status;
  function announce(msg) {
    if (!status) { status = d.createElement('div'); status.className = 'qm-vh'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); d.body.appendChild(status); }
    status.textContent = ''; setTimeout(function () { status.textContent = msg; }, 60);
  }
  function panelFor(el) {
    var href = el.getAttribute('href');
    if (href && href.charAt(0) === '#' && href.length > 1) { try { var t = d.querySelector(href); if (t) return t; } catch (e) {} }
    return el.nextElementSibling;
  }
  function syncExpanded(el) { var p = panelFor(el); if (p) el.setAttribute('aria-expanded', visible(p) ? 'true' : 'false'); }

  function run() {
    /* Collection toolbar: Filter / Sort toggles and sort options (2.1.1, 4.1.2) */
    each('.toolbar-item.toolbar-sidebar[data-sidebar], .toolbar [data-sidebar]', function (el) { keyButton(el, 'Filter'); el.setAttribute('aria-haspopup', 'dialog'); });
    each('.label-tab[data-toggle]', function (el) { keyButton(el, 'Sort'); });
    each('[data-sort-by-item]', function (el) { keyButton(el); });
    /* Filter sidebar category links carried aria-label="link" (2.5.3) */
    each('#halo-sidebar a[aria-label="link"], .halo-sidebar a[aria-label="link"]', function (el) { if (el.textContent.trim()) el.removeAttribute('aria-label'); });
    /* Footer accordions on phones: headings become buttons with state (2.1.1, 4.1.2) */
    each('.footer-block__heading[data-toggle-column-footer]', function (el) {
      keyButton(el); syncExpanded(el);
      if (!el.dataset.qmSync) { el.dataset.qmSync = '1'; el.addEventListener('click', function () { setTimeout(function () { syncExpanded(el); }, 450); }); }
    });
    /* Product page accordions: expose open/closed state (4.1.2) */
    each('a.toggleLink', function (el) {
      if (!el.getAttribute('role')) el.setAttribute('role', 'button');
      syncExpanded(el);
      if (!el.dataset.qmSync) { el.dataset.qmSync = '1'; el.addEventListener('click', function () { setTimeout(function () { each('a.toggleLink', syncExpanded); }, 450); }); }
    });
    /* Gallery zoom trigger and sticky add-to-cart close (2.1.1, 4.1.2) */
    each('.productView-iconZoom', function (el) { keyButton(el, 'Zoom image'); });
    each('.sticky-product-close', function (el) { if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', 'Close'); el.setAttribute('role', 'button'); });
    /* Variant swatches: give each option a spoken name and sold-out state (1.3.1, 4.1.2) */
    each('input.product-form__radio', function (inp) {
      var lab = (inp.id && d.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(inp.id) : inp.id) + '"]')) || inp.nextElementSibling;
      if (!lab || lab.tagName !== 'LABEL' || lab.querySelector('.qm-vh')) return;
      var sold = /(^|\s)soldout(\s|$)|sold-out|disable/.test(lab.className);
      var s = d.createElement('span'); s.className = 'qm-vh';
      s.textContent = (lab.textContent.trim() ? '' : (inp.value || '')) + (sold ? (lab.textContent.trim() ? ' (sold out)' : ', sold out') : '');
      if (s.textContent) lab.appendChild(s);
    });
    /* Wide comparison tables in articles must be scrollable by keyboard (2.1.1) */
    each('.qm-scroll', function (el) { if (el.scrollWidth > el.clientWidth + 2 && !el.hasAttribute('tabindex')) { el.setAttribute('tabindex', '0'); el.setAttribute('role', 'region'); el.setAttribute('aria-label', 'Scrollable table'); } });
    /* FAQ wrappers carried aria-expanded without a role (4.1.2) */
    each('div.card-header[aria-expanded]:not([role])', function (el) { if (el.querySelector('[role="button"]')) el.removeAttribute('aria-expanded'); });
    /* Product descriptions pasted from WhatsApp mark every bullet as a heading; keep the look, drop the false heading role (1.3.1, 2.4.6) */
    each('[id^="tab-description"] h3, [id^="tab-description"] h4, [id^="tab-description"] h5, [id^="tab-description"] h6, .productView-description h3, .productView-description h4, .productView-description h5, .productView-description h6', function (h) {
      if (!h.getAttribute('role') && /^[\s\u2060\u00a0]*[\u2022\u25CF\-\u2013]/.test(h.textContent)) h.setAttribute('role', 'none');
    });
    /* Rotating announcement bar must not keep re-announcing (4.1.3) */
    each('.announcement-bar [aria-live]', function (el) { el.setAttribute('aria-live', 'off'); });
    /* Round 3: one banner landmark for the header, distinct names for the two announcement regions,
       section titles at level 2 under the page H1 (1.3.1, 2.4.6). Looks are unchanged. */
    if (!d.querySelector('header, [role="banner"]')) { var hd = d.querySelector('.shopify-section-group-header-group sticky-header, sticky-header.hc-header'); if (hd) hd.setAttribute('role', 'banner'); }
    each('.shopify-section-group-footer-group [role="region"][aria-label="Announcement"]', function (el) { el.setAttribute('aria-label', 'Footer announcement'); });
    each('.halo-block-header h3.title, .title-wrap > h3.title', function (h) { if (!h.hasAttribute('aria-level') && !h.closest('.card, .product-item, .productListing')) h.setAttribute('aria-level', '2'); });
    slickFix();
  }

  /* Slick carousels: the track is not a listbox and slides are not options, so product links inside
     read as plain links; dot lists stop claiming to be tab lists (4.1.2). Slick re-applies its roles
     after every slide change, hence the event hook below. */
  function slickFix() {
    each('.slick-track[role="listbox"]', function (el) { el.removeAttribute('role'); });
    each('.slick-slide[role="option"], .slick-slide[role="tabpanel"]', function (el) { el.removeAttribute('role'); el.removeAttribute('aria-describedby'); });
    each('.slick-dots[role="tablist"]', function (el) { el.removeAttribute('role'); each('[role="presentation"], [role="tab"]', function (x) { x.removeAttribute('role'); x.removeAttribute('aria-selected'); x.removeAttribute('aria-controls'); }, el); });
  }
  var slickHooked = false;
  function hookSlick() {
    if (slickHooked || !window.jQuery) return; slickHooked = true;
    try { jQuery(d).on('init reInit afterChange breakpoint setPosition', '.slick-slider', function () { setTimeout(slickFix, 0); }); } catch (e) {}
  }

  /* Filter drawer as a dialog: move focus in, Escape closes, focus returns (2.1.2, 2.4.3) */
  var lastToggle = null;
  function sidebar() { return d.getElementById('halo-sidebar') || d.querySelector('.halo-sidebar'); }
  function sidebarOpen() { if (d.body.classList.contains('open-mobile-sidebar')) return true; var s = sidebar(); if (!s || !visible(s)) return false; var r = s.getBoundingClientRect(); return r.right > 40 && r.left < window.innerWidth - 40; }
  d.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-sidebar]');
    if (!t) return; lastToggle = t;
    setTimeout(function () {
      var s = sidebar(); if (!s || !sidebarOpen()) return;
      s.setAttribute('role', 'dialog'); s.setAttribute('aria-modal', 'true'); if (!s.getAttribute('aria-label')) s.setAttribute('aria-label', 'Filters');
      var f = s.querySelector('.halo-sidebar-close, [data-close-sidebar], button, a[href], input, [tabindex="0"]'); if (f) f.focus();
    }, 450);
  }, true);
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !sidebarOpen()) return;
    var s = sidebar(); var c = s.querySelector('.halo-sidebar-close, [data-close-sidebar], .close');
    if (c) c.click(); else d.body.classList.remove('open-mobile-sidebar');
    if (lastToggle) setTimeout(function () { try { lastToggle.focus(); } catch (x) {} }, 300);
  });

  /* Phone toolbar Search: move focus into the panel it opens (2.4.3) */
  d.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-search-mobile]'); if (!t) return;
    setTimeout(function () { var inputs = d.querySelectorAll('input[type="search"], input[name="q"]'); for (var i = 0; i < inputs.length; i++) { if (visible(inputs[i])) { inputs[i].focus(); break; } } }, 450);
  }, true);

  /* Announce result counts after filtering or sorting (4.1.3) */
  function announceCount() {
    var cards = d.querySelectorAll('#MainContent .productListing .product, #MainContent .product-item, #MainContent .card[data-product-id]');
    var n = 0; Array.prototype.forEach.call(cards, function (c) { if (visible(c)) n++; });
    var total = d.querySelector('#MainContent [data-products-count], #MainContent .collection-product-count');
    announce(total && total.textContent.trim() ? total.textContent.trim() : (n + ' products shown'));
  }
  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m]; if (!orig) return;
    history[m] = function () { var r = orig.apply(this, arguments); try { if (/\/collections\/|\/search/.test(location.pathname)) setTimeout(function () { run(); announceCount(); }, 1400); } catch (e) {} return r; };
  });

  /* Pause control for the moving announcement bar and footer marquee (2.2.2); auto-paused for reduced motion */
  function motionToggle() {
    var bar = d.querySelector('.announcement-bar'); if (!bar || bar.querySelector('.qm-motion-toggle')) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var b = d.createElement('button'); b.type = 'button'; b.className = 'qm-motion-toggle';
    function set(paused) {
      d.documentElement.classList.toggle('qm-motion-paused', paused);
      b.setAttribute('aria-pressed', paused ? 'true' : 'false'); b.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
      b.textContent = paused ? '▶' : '❚❚';
      try { if (window.jQuery) jQuery(bar).find('.slick-initialized').slick(paused ? 'slickPause' : 'slickPlay'); } catch (e) {}
    }
    b.addEventListener('click', function () { set(!d.documentElement.classList.contains('qm-motion-paused')); });
    if (getComputedStyle(bar).position === 'static') bar.style.position = 'relative';
    bar.appendChild(b); set(!!reduce);
  }

  var pending = null;
  function schedule() { if (pending) return; pending = setTimeout(function () { pending = null; run(); }, 600); }
  function start() {
    run(); hookSlick(); try { motionToggle(); } catch (e) {}
    try { new MutationObserver(schedule).observe(d.body, { childList: true, subtree: true }); } catch (e) {}
    window.addEventListener('load', function () { hookSlick(); run(); try { motionToggle(); } catch (e) {} });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
